import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { formatDateTime } from "@/lib/helpers";
import { StickyNote } from "lucide-react";

// Student Detail -> "Notes" card. Extracted from StudentDetail.js
// (props-driven, no behavior change).
export const NotesCard = ({ notes, canAddNote, noteText, onNoteTextChange, onAddNote }) => (
  <section className="rounded-[var(--radius)] border bg-card p-4 sm:p-5 space-y-3" data-testid="notes-card">
    <h2 className="font-semibold font-heading flex items-center gap-2"><StickyNote className="h-4 w-4" /> Notes</h2>
    {canAddNote && (
      <div className="space-y-2">
        <Textarea value={noteText} onChange={(e) => onNoteTextChange(e.target.value)} placeholder="Add a note about this student..." data-testid="student-note-input" />
        <Button size="sm" onClick={onAddNote} data-testid="student-note-submit-button">Add Note</Button>
      </div>
    )}
    <div className="space-y-3 max-h-64 overflow-y-auto">
      {(notes || []).slice().reverse().map((n) => (
        <div key={n.id} className="text-sm border-l-2 border-[hsl(var(--role-accent))] pl-3" data-testid="student-note-item">
          <p>{n.note}</p>
          <p className="text-xs text-muted-foreground">{n.created_by} · {formatDateTime(n.created_at)}</p>
        </div>
      ))}
      {(!notes || notes.length === 0) && (
        <p className="text-sm text-muted-foreground">No notes yet.</p>
      )}
    </div>
  </section>
);
